module.exports = __webpack_public_path__ + "img/logo-ai.dc861681.png";